import { render, staticRenderFns } from "./TakeOutEleDetail2.vue?vue&type=template&id=0eebb66d"
import script from "./TakeOutEleDetail2.vue?vue&type=script&lang=js"
export * from "./TakeOutEleDetail2.vue?vue&type=script&lang=js"
import style0 from "./TakeOutEleDetail2.vue?vue&type=style&index=0&id=0eebb66d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports